import { ApplicationAnswerProps } from '@/models/Application';
import { QuestionProps } from '@/models/Question';
import { QuestionDependencyProps } from '@/models/QuestionDependency';

export const showChildQuestion = (
  question: QuestionProps,
  answers: Partial<Record<number, ApplicationAnswerProps>>
): boolean => {
  if (question?.parentQuestion == null || question.parentQuestion.length <= 0) return false;

  const parentQuestionIds = question.parentQuestion.map(
    (x: QuestionDependencyProps) => x.parentQuestionId
  );

  // get answers where the key matches a parent question id
  const matchyKeys = Object.keys(answers)
    .map((key) => parseInt(key))
    .filter((key) => parentQuestionIds.includes(key));

  // get the values from answers that match the parent question id
  const matchy = matchyKeys.map((key) => answers[key]);

  if (matchy) {
    const pids = question?.parentQuestion
      .map(function (p) {
        return p.parentQuestionChoiceId;
      })
      .flat()
      .sort();

    const cids = matchy
      .map(function (p: ApplicationAnswerProps) {
        return p.choices?.map((x: any) => x.choiceId);
      })
      .flat()
      .sort();

    return isThereAParentMatch(pids, cids);
  }

  return false;
};

// TODO(bug): the match is non-monotonic when the parent has more than one trigger choice. With
// trigger choices [A, B]: selecting [A] shows the child (current ⊆ parent) and [A, B, C] shows it
// (parent ⊆ current), but [A, C] hides it (same length, neither contains the other). Expected: one
// consistent rule — most likely "any selected choice is a trigger choice" (non-empty intersection).
// Note showChildQuestion also pools trigger/selected choice ids across *all* parent questions.
export const isThereAParentMatch = (parentAnswer: number[], currentAnswer: number[]): boolean => {
  if (!currentAnswer || currentAnswer.length <= 0) return false;

  if (parentAnswer.length > 0 && parentAnswer.length <= currentAnswer.length) {
    if (arrayContainedInOther(currentAnswer, parentAnswer)) {
      return true;
    } else {
      return false;
    }
  } else if (parentAnswer.length > 0 && parentAnswer.length > currentAnswer.length) {
    if (arrayContainedInOther(parentAnswer, currentAnswer)) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};

export const arrayContainedInOther = (a: unknown[], b: unknown[]) => {
  return b.every((el: unknown) => {
    return a.includes(el);
  });
};
